import React from 'react';
import { Skeleton } from '@mui/material';
import { Link } from 'react-router-dom';
import styles from './PlanUsageCard.module.css';

const levelOf = (current, limit) => {
  if (limit === null || current === null) return 'ok';
  const pct = limit > 0 ? current / limit : 1;
  if (pct >= 1) return 'full';
  if (pct >= 0.8) return 'near';
  return 'ok';
};

/** Uma linha de uso: rótulo, "3 de 5" (ou "Sem limite") e barra. */
const UsageMeter = ({ label, current, limit, note }) => {
  const level = levelOf(current, limit);
  const pct = limit && current !== null ? Math.min((current / limit) * 100, 100) : (limit === 0 ? 100 : 0);

  return (
    <div className={styles.meter}>
      <div className={styles.meterHead}>
        <span className={styles.meterLabel}>{label}</span>
        {current === null ? (
          <Skeleton variant="text" width={64} />
        ) : (
          <span className={`${styles.meterCount} ${styles[`count_${level}`]}`}>
            {limit === null ? `${current} · Sem limite` : `${current} de ${limit}`}
          </span>
        )}
      </div>
      {limit === null ? (
        <div className={styles.track}>
          <div className={styles.fillUnlimited} />
        </div>
      ) : (
        <div className={styles.track}>
          <div className={`${styles.fill} ${styles[`fill_${level}`]}`} style={{ width: `${current === null ? 0 : pct}%` }} />
        </div>
      )}
      {(note || level !== 'ok') && (
        <div className={styles.meterFoot}>
          {note && <span>{note}</span>}
          {level !== 'ok' && (
            <Link to="/subscription/plans" className={styles.meterLink}>Ver planos</Link>
          )}
        </div>
      )}
    </div>
  );
};

export default UsageMeter;
